export const popoverLaraThemeConfig = {
  contentPadding: "0px",
  gutter: "var(--spacing-4)",
  borderRadius: "var(--radius-8)",
  shadow: "var(--shadow-lg)",
  css: () => `
    .p-popover:before, .p-popover:after {
      content: unset;
    }
  `,
};
